import { ErrorResponse } from '@/shared/types';
import { useMutation } from '@tanstack/react-query';
import axios, { AxiosError } from 'axios';

interface UploadThumbnailToS3Params {
  thumbnailBlob: Blob;
  presignedUrl: string;
  onProgress?: (progress: number) => void;
}

/**
 * 썸네일을 Pre-signed URL로 업로드합니다.
 */
export const uploadThumbnailToS3Api = async ({
  thumbnailBlob,
  presignedUrl,
  onProgress,
}: UploadThumbnailToS3Params): Promise<void> => {
  try {
    const response = await axios.put(presignedUrl, thumbnailBlob, {
      headers: {
        'Content-Type': thumbnailBlob.type || 'image/jpeg',
        // TODO: 백엔드 presigned URL 서명에 Cache-Control 미포함 → S3 오브젝트 메타데이터에 설정 안 됨
        // be-api AbstractAwsS3Service.putObjectPreSignRequest에 .contentCacheControl() 추가 필요
        'Cache-Control': 'public, max-age=259200',
      },
      onUploadProgress: (progressEvent) => {
        if (progressEvent.total) {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total,
          );
          if (onProgress) {
            onProgress(percentCompleted);
          }
        } else {
          console.warn('Thumbnail upload progress total size is unknown.');
          if (onProgress) {
            onProgress(0);
          }
        }
      },
    });

    if (onProgress) {
      onProgress(100);
    }

    return response.data;
  } catch (error) {
    if (onProgress) {
      onProgress(0);
    }
    console.error('S3 Thumbnail Upload Error:', error);
    throw error;
  }
};

export const usePutUploadThumbnailToS3 = () => {
  return useMutation<
    void,
    AxiosError<ErrorResponse>,
    UploadThumbnailToS3Params
  >({
    mutationFn: uploadThumbnailToS3Api,
  });
};
